import { Routes } from '@angular/router';
import { maintenanceGuard } from '@core/guard/maintenance.guard';
import { noAuthGuard } from '@core/guard/noauth.guard';
import { provideTranslocoScope } from '@jsverse/transloco';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    canActivate: [maintenanceGuard, noAuthGuard],
    canActivateChild: [noAuthGuard],
    providers: [provideTranslocoScope('auth')],
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('@features/auth/pages/login-page/login-page.component').then((m) => m.LoginPageComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('@features/auth/pages/register-page/register-page.component').then((m) => m.RegisterPageComponent),
      },
      {
        path: 'otp-verification',
        loadComponent: () =>
          import('@features/auth/pages/otp-verification-page/otp-verification-page.component').then(
            (m) => m.OtpVerificationPageComponent,
          ),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('@features/auth/pages/forget-password-page/forget-password-page.component').then(
            (m) => m.ForgetPasswordPageComponent,
          ),
      },
      {
        path: 'forget-password/reset',
        loadComponent: () =>
          import('@features/auth/pages/forget-password-reset-page/forget-password-reset-page.component').then(
            (m) => m.ForgetPasswordResetPageComponent,
          ),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
];
